export class BuyPriceDetails {
  boughtRange: PriceRange;
  history: BuyPriceHistoryItem[];
  notBoughtRange: PriceRange;
  range?: PriceRange;
  notRange?: PriceRange;
}

export class SellPriceDetails {
  soldRange: PriceRange;
  history: SellPriceHistoryItem[];
  notSoldRange: PriceRange;
  range?: PriceRange;
  notRange?: PriceRange;
}
export class PriceRange {
  average?: number;
  max?: number;
  min?: number;
  numVehicles?: number;
}
export class BuyPriceHistoryItem {
  bought?: boolean;
  boughtAt?: Date;
  createdAt?: Date;
  fipeDiff?: number;
  make?: string;
  manufactureYear?: number;
  model?: string;
  modelYear?: number;
  price?: number;
  trim?: string;
}

export class SellPriceHistoryItem {
  fipeDiffInitialBid?: number;
  fipeDiffLastBid?: number;
  initialBid?: number;
  lastBid?: number;
  make?: string;
  manufactureYear?: number;
  margin?: number;
  model?: string;
  modelYear?: number;
  soldAt?: string;
  trim?: string;
}

export enum RegionEnum {
  "S" = "Sul",
  "N" = "Norte",
  "NE" = "Nordeste",
  "SE" = "Sudeste",
  "CO" = "Centro-Oeste",
}